module.exports = __webpack_public_path__ + "img/gb13681.prt.66784d07.jpg";